import { createIcon } from '../utils';

export const MessageChatIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_message_chat)">
        <path
          d="M4.57077 8.4216C4.52416 8.12117 4.49997 7.81339 4.49997 7.5C4.49997 4.18629 7.20394 1.5 10.5394 1.5C13.875 1.5 16.5789 4.18629 16.5789 7.5C16.5789 8.24855 16.4409 8.96509 16.1889 9.62588C16.1365 9.76312 16.1103 9.83173 16.0984 9.88531C16.0867 9.93839 16.0821 9.97573 16.0808 10.0301C16.0796 10.0849 16.087 10.1454 16.1019 10.2662L16.4038 12.7189C16.4365 12.9844 16.4528 13.1172 16.4087 13.2137C16.37 13.2982 16.3012 13.3654 16.2158 13.4021C16.1183 13.4441 15.986 13.4247 15.7213 13.3859L13.3323 13.0357C13.2076 13.0174 13.1452 13.0083 13.0884 13.0086C13.0322 13.0089 12.9934 13.013 12.9384 13.0246C12.8828 13.0363 12.8118 13.0629 12.6697 13.1161C12.0073 13.3642 11.2893 13.5 10.5394 13.5C10.2258 13.5 9.91775 13.4762 9.617 13.4305M5.72368 16.5C7.94736 16.5 9.75 14.6532 9.75 12.375C9.75 10.0968 7.94736 8.25 5.72368 8.25C3.50001 8.25 1.69737 10.0968 1.69737 12.375C1.69737 12.8329 1.77021 13.2735 1.90466 13.685C1.9615 13.859 1.98992 13.946 1.99924 14.0055C2.00898 14.0675 2.01069 14.1023 2.00706 14.165C2.00359 14.2251 1.98856 14.293 1.95851 14.4287L1.5 16.5L3.7461 16.1932C3.8687 16.1765 3.93 16.1681 3.98353 16.1685C4.03989 16.1689 4.0698 16.1719 4.12508 16.183C4.17758 16.1934 4.25562 16.221 4.4117 16.276C4.82294 16.4212 5.26433 16.5 5.72368 16.5Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_message_chat">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  { displayName: 'MessageChatIcon', defaultSize: 18 },
);
